import { HttpClient } from "@angular/common/http";
import { Pipe, PipeTransform } from "@angular/core";
import { Observable, catchError, finalize, first, map, of, switchMap } from "rxjs";

@Pipe({
    name: 'imgFromChain'
})
export class ImgFromChainPipe implements PipeTransform {
    // private cache: { [url: string]: Observable<string> } = {};
    constructor(
        private httpClient: HttpClient
    ) { }

    transform(value: string): Observable<string> {

        // let url = 'https://ipfs.kryptomon.co/ipfs/' + value.replace('ipfs://', '');
        // if (!this.cache[url]) {
        //     this.cache[url] = this.httpClient.get<any>(url).pipe(
        //         map(response => response.image),
        //         catchError(error => {
        //             console.error('Error fetching image property:', error);
        //             return of(''); // Ritorna una stringa vuota in caso di errore
        //         }),
        //         finalize(() => delete this.cache[url]) // Rimuove la cache dopo il completamento
        //     );
        // }
        // return this.cache[url];
        let url = 'https://ipfs.kryptomon.co/ipfs/' + value.replace('ipfs://', '');
        return this.httpClient.get<{ image: string }>(url).pipe(
            map(response => 'https://ipfs.kryptomon.co/ipfs/' + response.image.replace('ipfs://', '')),
            first()
        );
    }

}

